import axios from "axios";
import DevSwitch from '../../../DevSwitch'

export function requestGetJPAilmentModifyCompare() {
  if (DevSwitch == true) {
    return axios.get('data/_dir/modify/JPCompare.json', { 'muteHttpExceptions': true })
  } else {
    return axios.get('https://www.dissidiacompendium.com/data/_dir/modify/JPCompare.json', { 'muteHttpExceptions': true })
  }
}
